<template>
  <div>
    <vxe-toolbar>
      <template #buttons>
        <Button type="default" @click="handleCompareClicked" :disabled="!compareBtnEnabled">Compare selected revisions</Button>
      </template>
    </vxe-toolbar>
    <vxe-table
      highlight-hover-row
      border
      resizable
      size="mini"
      :data="revisions"
      :checkbox-config="{ showHeader: false }"
      @checkbox-change="handleSelectChange">
      <vxe-table-column type="checkbox" width="40"></vxe-table-column>
      <vxe-table-column field="version" title="Version #" width="100"></vxe-table-column>
      <vxe-table-column field="reason" title="Message" width="420"></vxe-table-column>
      <vxe-table-column field="user.name" title="User" width="140"></vxe-table-column>
      <vxe-table-column field="created_at" title="Created" width="160"></vxe-table-column>
      <vxe-table-column title="Action" width="120" align="center">
        <template #default="{ row }">
          <Button type="text" size="small" @click="handleViewBomVersionLinkClick(row)">View</Button>
        </template>
      </vxe-table-column>
    </vxe-table>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'BOMRevisionList',
  props: {
    bomId: Number,
    bomVersion: String
  },
  data () {
    return {
      revisions: [],
      selected: []
    }
  },
  computed: {
    compareBtnEnabled () {
      return this.selected.length === 2
    }
  },
  methods: {
    ...mapActions(['getBomVersions']),
    handleCompareClicked () {
      let location = this.$router.resolve({
        name: 'menu.bom.versions',
        params: { bomId: this.bomId, version: this.selected[0].version, version_compare: this.selected[1].version }
      })

      window.open(location.href, '_blank')
    },
    handleSelectChange ({ checked, records }) {
      this.selected = records
    },
    handleViewBomVersionLinkClick (row) {
      const path = this.$router.resolve({ name: 'menu.bom.view', params: { bomId: row.versionable_id }, query: { version: row.version } })
      window.open(path.href, '_blank')
    }
  },
  mounted () {
    this.getBomVersions({ id: this.bomId }).then(resp => {
      this.revisions = resp.data
    })
  }
}
</script>
